import axios from "axios"
import packageJson from "../package.json"
import router from "./router"
import { useAlertStore } from "@/stores/alert"
import { AlertType } from "@/static/Alert"
import { i18n } from "@/i18n"

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { "X-App-Version": packageJson.version },
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")

    if (token) {
      config.headers.Authorization = "Bearer " + token
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const alerts = useAlertStore()

    if (error.response?.status === 401 && error.config?.url !== "/auth/login") {
      let redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin") ||
        window.location.pathname + window.location.search + window.location.hash

      // pour éviter une redirection infinie sur la page de login
      const authUrl = import.meta.env.VITE_APP_URL + 'authentication'

      if (redirectAfterLogin === authUrl) {
        redirectAfterLogin = window.location.pathname + window.location.search + window.location.hash
      }

      router.push({ name: "auth" })
      alerts.push(AlertType.info, "Votre session a expirée")
      localStorage.clear()

      if (redirectAfterLogin !== '/authentication') {
        sessionStorage.setItem("redirectAfterLogin", redirectAfterLogin)
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient
